import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const supportedLngs = ['pt-BR', 'en', 'es'];

const normalizeDetectedLanguage = (lng) => {
  if (!lng) return 'en';

  const lowerLng = lng.toLowerCase();

  if (lowerLng.startsWith('pt')) return 'pt-BR';
  if (lowerLng.startsWith('es')) return 'es';
  if (lowerLng.startsWith('en')) return 'en';

  return lng;
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs,
    ns: ['common', 'download', 'landing', 'pricing', 'login', 'account'],
    defaultNS: 'common',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupQuerystring: 'lng',
      convertDetectedLanguage: normalizeDetectedLanguage,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
